<template>
  <table-layout title="نرخ پست" :showSearch="false">
    <template #buttons>
      <router-link :to="{ name: 'CreateDelivery' }" class="ml-2">
        <b-button pill variant="purple"> ساخت نرخ جدید</b-button>
      </router-link>
    </template>
    <template #table>
      <table-items :items="deliveries" :restoreState="false"/>
      <b-row class="pt-3 mt-3">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </b-row>
    </template>
  </table-layout>
</template>

<script>
import TableLayout from "../../components/dashboard/TableLayout.vue";
import tableItems from "../../components/dashboard/Delivery/tableItems.vue";
import {mapGetters} from "vuex";
import Pagination from "../../components/dashboard/Pagination.vue";


export default {
  name: "Deliveries",
  components: {TableLayout, tableItems, Pagination},
  computed: {
    ...mapGetters({
      deliveries: "Delivery/getDeliveries",
      paginationMeta: "Delivery/getMeta",
    }),
  },
  mounted() {
    this.$store.dispatch('Delivery/getDeliveries', 1)

  },
  methods: {
    changePage(page) {
      this.$store.dispatch("Delivery/getDeliveries", page);
    },

  }
};
</script>